<template>
  <div class="lottery" :style="{backgroundColor: cc.lottery_area_bg_color}">
    <div class="lottery-wrapper">
      <div class="lottery-box" ref="lottery-box">
        <div class="lottery-list active" ref="lottery-list"></div>
        <div class="mask mask-left" :style="{'background': cc.mask_color}"></div>
        <div class="mask mask-right" :style="{'background': cc.mask_color}"></div>
      </div>
      <div class="lottery-line"></div>
    </div>
    <slot></slot>
  </div>
</template>

<script type='text/ecmascript-6'>
export default {
  props: {
    prize_list: {
      type: Array,
      default: () => []
    },
    app: {
      type: Object,
      default: () => {}
    },
    cc: {
      type: Object,
      default: () => {}
    },
    gc: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      clientWidth: 0, // 展示区域宽度
      itemWidth: 165, // 奖品子项宽
      s_counts: 1,
      speed: 100, // 
      canClick: true,
      left: 0
    }
  },
  mounted () {
    this.getAnimateProperty()
    this.$box = this.$refs['lottery-box']
    this.$list = this.$refs['lottery-list']
    this.clientWidth = this.$box.clientWidth
    this.initialLottery()
  },
  methods: {
    setLotteryResult () {
      clearTimeout(this.scroll_timer)
      this.initialLotteryStart()
    },
    findPrizeIndex (id) {
      var index = 0
      for (let i=0; i<this.prize_list.length; i++) {
        if (this.prize_list[i].award_id == id) {
          index = i+1
          break;
        }
      }
      return index
    },
    resetLottery () {
      this.canClick = true
      this.s_counts = 1
      this.$list.innerHTML = ''
      this.$list.style = `width:${this.prize_list.length * this.itemWidth}px; ${this._transition}: all 0 ease 0; ${this._transform}: translate3d(0, 0, 0);`
      setTimeout(() => {
        this.initialLottery()
      }, 100)
    },
    initialLotteryStart () {
      this._initialBoxItem()

      let transX = -330+this.clientWidth/2+this.itemWidth/2
      this.$list.style = `width:${40 * this.itemWidth}px; ${this._transition}: all 0 ease 0; ${this._transform}: translate3d(${transX}px, 0, 0);`

      var times = 32

      setTimeout(() => {
        this.lotteryScrollAnimate(times, transX)
      }, 0)
    },
    _initialBoxItem () {
      this.$list.innerHTML = ''
      var fragment = document.createDocumentFragment()
      for (let i=0; i<40; i++) {
        var prize = document.createElement('div')
        prize.className = `lottery-item-box`
        prize.style['border-color'] = this.cc.theme_color
        prize.innerHTML = `<img src="https://cdn.max-c.com/heybox/dailynews/img/3cbcb867679780138e02ac72c1be2234.jpg">`
        fragment.appendChild(prize)
      }
      this.$list.style.width = 40 * this.itemWidth + 'px'
      this.$list.appendChild(fragment)
    },
    lotteryScrollAnimate (times, transX) {
      var w = this.$list.children.length * this.itemWidth
      var distance = times * this.itemWidth
      var time = distance / 825 * 1000
      this.$list.style = `width:${w}px; ${this._transition}: transform ${time}ms cubic-bezier(0.45, 0.18, 0.26, 1); ${this._transform}: translate3d(${transX - distance}px,0,0);`

      setTimeout(() => {
        this.$emit('show')
      }, time+300)
      setTimeout(() => {
        this.resetLottery()
      }, time+1000)
    },
    pushOneItem (index) {
      var item = this.prize_list[index]
      var prize = document.createElement('div')
      prize.className = `lottery-item color-${item.rarity}`
      var desc = ['传说', '史诗', '稀有', '普通'][item.rarity-1]
      prize.innerHTML = 
      `<div class="prize-name"><p style="color: ${this.gc.main_color}">${item.name}</p></div>
      <div class="image-box"><img src="${item.img}" alt=""><p class="tag">${desc}</p></div>`
      this.$list.appendChild(prize)
    },
    initialLottery () {
      this._initialItem()
      this._initialItem()
      this.$nextTick(() => {
        this.initialScrollAnimate()
      })
    },
    initialScrollAnimate () {
      this.scroll_timer = setInterval(() => {
        if (this.left > this.prize_list.length * this.itemWidth) {
          this.left = 0
        }
        this.$list.setAttribute('style', `${this._transform}: translate3d(-${this.left++}px, 0, 0);`)
      }, 17)
    },
    _initialItem () {
      var fragment = document.createDocumentFragment()
      this.prize_list.forEach((item) => {
        var prize = document.createElement('div')
        prize.className = `lottery-item color-${item.rarity}`
        var desc = ['传说', '史诗', '稀有', '普通'][item.rarity-1]
        prize.innerHTML =
        `<div class="prize-name"><p style="color: ${this.gc.main_color}">${item.name}</p></div>
        <div class="image-box"><img src="${item.img}" alt=""><p class="tag">${desc}</p></div>`
        fragment.appendChild(prize)
      })
      this.$list.style.width = 2 * this.prize_list.length * this.itemWidth + 'px'
      this.$list.appendChild(fragment)
    },
    openRecordModal () {
      if (!this.$parent.is_in_heybox) {
        this.$parent.openInHeybox()
        return
      }
      this.$emit('openmodal')
    },
    getAnimateProperty () {
      var el = document.createElement('p')
      var transitions = ['transition', 'oTransition', 'msTransition', 'mozTransition', 'webkitTransition']
      var transforms = ['transform', 'oTransform', 'msTransform', 'mozTransform', 'webkitTransform']
      for (let key in transitions) {
        if (transitions[key] in el.style) {
          this._transition = transitions[key]
          this._transform = transforms[key]
          break;
        }
      }
    }
  }
}
</script>

<style lang='less' scoped>
  .lottery {
    width: 100%;
    border-radius: 4px;
    .lottery-desc {
      margin-top: 12px;
      height: 16px;
      line-height: 16px;
      text-align: center;
      color: rgba(255, 255, 255, 0.2);
      font-size: 12px;
    }
    
    .lottery-wrapper {
      width: 100%;
      height: 123px;
      position: relative;
      padding: 10px 0;
      .lottery-line {
        position: absolute;
        top: 5px;
        left: 50%;
        transform: translateX(-50%);
        width: 3px;
        height: 121px;
        background: url('../assets/images/line.png') no-repeat;
        background-size: 100% 100%;
      }
        
      .lottery-box {
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        position: relative;
        // background-color: #121212;
        transform: translate3d(0,0,0);
        overflow: hidden;
       
        .mask {
          width: 40px;
          height: 100%;
          position: absolute;
          top: 0;
          background: linear-gradient(90deg, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0) 100%);
          z-index: 2;
          user-select: none;
          pointer-events: none;
          &.mask-left {
            left: 0;
          }
          &.mask-right {
            right: 0;
            transform: rotate(180deg);
          }
        }
          
        /deep/ .lottery-list  {
          height: 100%;
          box-sizing: border-box;
          display: flex;
          align-items: center;
          position: absolute;
          left: 0;
          top: 0;
          z-index: 1;
          .lottery-item-box {
            width: 155px;
            height: 100%;
            padding: 6px;
            border-radius: 4px;
            float: left;
            margin: 0 5px;
            background-color: #000;
            position: relative;
            overflow: hidden;
            border: 1px solid;
            img {
              width: 100%;
              height: 100%;
              float: left;
              border-radius: 4px;
            }
          }

          .lottery-item {
            width: 155px;
            height: 100%;
            box-sizing: border-box;
            padding: 6px;
            border-radius: 4px;
            float: left;
            margin: 0 5px;
            background-color: #000;
            position: relative;
            overflow: hidden;
            &.color-1 {
              border: 1px solid #fe7f00;
              background-color: rgba(#fe7f00, 0.1);
              .image-box .tag {
                background-color: #fe7f00;
              }
            }
              
            &.color-2 {
              border: 1px solid #7a60ff;
              background-color: rgba(#7a60ff, 0.1);
              .image-box .tag {
                background-color: #7a60ff;
              }
            }
              
            &.color-3 {
              border: 1px solid #00b1fb;
              background-color: rgba(#00b1fb, 0.1);
              .image-box .tag {
                background-color: #00b1fb;
              }
            }
            
            &.color-4 {
              border: 1px solid #46cc76;
              background-color: rgba(#46cc76, 0.1);
              .image-box .tag {
                background-color: #46cc76;
              }
            }

            .prize-name {
              width: 100%;
              height: 16px;
              display: flex;
              justify-content: center;
              align-items: center;
              p {
                font-size: 11px;
                color: #fff;
                height: 11px;
                line-height: 11px;
                max-width: 100%;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }

            .image-box {
              width: 100%;
              height: 71px;
              position: relative;
              margin-top: 5px;
              img {
                width: 100%;
                min-height: 100%;
                position: absolute;
                top: 50%;
                left: 0;
                transform: translateY(-50%);
                border-radius: 2px;
              }
              .tag {
                height: 20px;
                line-height: 20px;
                width: 100px;
                font-size: 11px;
                transform: rotate(-45deg) translateX(50%);
                color: #fff;
                text-align: center;
                position: absolute;
                bottom: -42%;
                right: 0px;
              }
            }
          }
        }
      }
    }
  }


        
          
            
              
                
</style>